// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"6c1a73e3","188":"6944d08e","453":"a04ae9d0","514":"6e7125c5","767":"88f62abc"}[chunkId] + ".chunk.js";
};